skyward.base.registerScript("dataobjectviewer", function (skyward, $)
{
    "use strict";

    var eventNames =
    {
        DOVSaveValidationError: "DOVSaveValidationError",
        DOVSaveComplete: "DOVSaveComplete",
        DOVSaveCanceled: "DOVSaveCanceled",
        DOVSaveInDetailsPanel: "DOVSaveInDetailsPanel",
    };

    skyward.dataobjectviewer = skyward.dataobjectviewer || {};

    /**
     * Save the  Data Object Viewer using the parameters specified when the viewpart was rendered on the server.
     *
     * @param {string} dovId - The id of the  Data Object Viewer to save
     * @return {Promise} A promise that is resolved when the save completes.
     */
    skyward.dataobjectviewer.defaultSave = function (dovId)
    {
        var saveButton = $("#" + dovId + "_save");
        if (saveButton.length === 1 && saveButton.hasClass("dirty"))
        {
            return saveHandler(saveButton, false);
        }
        return $.Deferred().reject();
    };

    /**
    * Save the  Data Object Viewer using the parameters specified when the viewpart was rendered on the server.
    * Then return to the previous screen.
    *
    * @param {string} dovId - The id of the  Data Object Viewer to save
    * @return {Promise} A promise that is resolved when the save completes.
    */
    skyward.dataobjectviewer.defaultSaveAndBack = function (dovId)
    {
        var saveButton = $("#" + dovId + "_saveBack");
        if (saveButton.length === 1 && saveButton.hasClass("dirty"))
        {
            return saveHandler(saveButton, true, false);
        }
        return $.Deferred().reject();
    };

    skyward.dataobjectviewer.cancel = skyward.buttonManager.manageButtonClick(doCancel);

    skyward.dataobjectviewer.save = skyward.buttonManager.manageButtonClick(doSave);

    skyward.dataobjectviewer.delete = skyward.buttonManager.manageButtonClick(doDelete);

    skyward.dataobjectviewer.addNewControl = function (container, enableDOVButtons)
    {
        var saveButton = $("#" + container + "_save");

        if (saveButton.length > 0)
        {
            $('[id*="iconSave"]').addClass("dirty");

            if (typeof enableDOVButtons === 'undefined' || enableDOVButtons)
            {
                skyward.dataobjectviewer.getFieldValues.enableButtons(container);
            }
        }
    };

    skyward.dataobjectviewer.removeControl = function (container)
    {
        var saveButton = $("#" + container + "_save");

        if (saveButton.length > 0)
        {
            $('[id*="iconSave"]').addClass("dirty");
        }
    };

    skyward.dataobjectviewer.updateCustomSaveData = function (input, datadictionary, forceKeep)
    {
        var saveData = customSaveDataFetcher.fetch(input);
        if (!saveData)
        {
            return;
        }

        for (var i = 0; i < datadictionary.length; i++)
        {
            var storedSaveData = datadictionary[i];
            if (storedSaveData.name == saveData.name)
            {
                if (storedSaveData.originalValue == saveData.value && !forceKeep)
                {
                    //remove save data from array
                    datadictionary.splice(i, 1);
                }
                else
                {
                    //update existing save data
                    datadictionary[i] = saveData;
                }
                return;
            }
        }

        // add save data
        if (saveData.originalValue != saveData.value || forceKeep)
        {
            datadictionary.push(saveData);
        }
    };

    /**
     * Perform client-side validation on fields in the specified container
     * @param {JQyuery} container - workflow or details screen's container to run pre-save validation on
     * @returns {boolean} - True if the container has no invalid fields or if the CMA is not locatable
     */
    skyward.dataobjectviewer.preSaveValidation = function (container)
    {
        const contentArea = container.parent();
        const cma = skyward.contentMessageArea.getContentMessageArea(contentArea);

        if (cma)
        {
            // Targets with pre-save errors will have these classes 'error-control js-error-control--preSaveValidation', pre-save warnings will have these classes 'warning-text js-warn-control--preSaveValidation'
            const preSaveValidation = container.find('.js-error-control--preSaveValidation');
            const preSaveWarning = container.find('.js-warn-control--preSaveValidation:not(.js-warn-control--preSaveIgnore)');

            if (preSaveValidation.length > 0 || preSaveWarning.length > 0)
            {
                // Take into account all errors/warnings on the screens when updating the CMA
                const errorCount = container.find('.help .error-text').length;
                const warnCount = container.find('.help .warning-text').length;
                cma.setValidationCount(errorCount, warnCount).showValidation();

                if (preSaveWarning.length > 0)
                {
                    preSaveWarning.addClass('js-warn-control--preSaveIgnore');
                }

                return false;
            }
        }
        return true;
    }

    var customSaveDataFetcher = (function ()
    {
        var customSaveDataFetcher = {};

        customSaveDataFetcher.fetch = function (input)
        {
            return input.saveJson ? getSaveDataFromObj(input) : getSaveDataFromField(input);
        };

        return customSaveDataFetcher;

        function getSaveDataFromField(input)
        {
            if (input.length < 1)
            {
                return;
            }

            var fieldValue = skyward.dataobjectviewer.getFieldValues.getFieldValueFromNamedInput(input);
            if (!fieldValue)
            {
                return;
            }

            var saveData =
            {
                name: fieldValue.name,
                value: fieldValue.value == null ? "" : fieldValue.value
            };

            appendInputData(saveData, input.data());

            return saveData;
        }

        function getSaveDataFromObj(obj)
        {
            var saveData =
            {
                name: obj.name,
                value: obj.value
            };

            appendInputData(saveData, obj.data);

            return saveData;
        }

        function appendInputData(saveData, inputData)
        {
            var defaultInputData = { originalValue: "" };

            inputData = $.extend({}, defaultInputData, inputData);

            saveData.originalValue = inputData.originalValue;

            var saveDataDictionary = {};
            // Keep this in sync with the keys defined in CustomSaveData.cs
            const allowedKeys = [
                "originalValue",
                "calculationGroupGradeBucketId",
                "categoryId",
                "poquantity",
                "previouslyreceived",
                "poamount",
                "previouslyreceivedamount",
                "approvalobjectid",
                "comment"
            ];
            $.each(inputData, function (key, dataValue)
            {
                if (allowedKeys.includes(key))
                {
                    if (isPlainObject(dataValue))
                    {
                        // originalValue is an object in cases of DMSE
                        saveDataDictionary[key] = JSON.stringify(dataValue);
                    }
                    else
                    {
                        saveDataDictionary[key] = dataValue;
                    }
                }
            });

            saveData.datadictionary = saveDataDictionary;
        }

        function isPlainObject(value)
        {
            return (
                typeof value === 'object' &&
                value !== null &&
                !Array.isArray(value) &&
                Object.prototype.toString.call(value) === '[object Object]'
            );
        }
    })();

    var redirectAfterAsyncProcess = function (data, container, area, controller, refreshAction, id, popupId, goBack, tab, savingInDetailsPanel, urlReferrer)
    {
        var deferred = $.Deferred();

        if (data.goBack || goBack)
        {
            skyward.window.setSkipUnloadCheck(true);
            skyward.window.returnToPrevious(refreshAction, urlReferrer);
            deferred.resolve();
        }
        else
        {
            if (tab != null)
            {
                container = "moduleContent";
            }
            skyward.window.setSkipUnloadCheck(true);

            var loadContentdata = data;

            loadContentdata.tab = data.excludeTab ? null : tab;

            if (savingInDetailsPanel)
            {
                skyward.browse.detailsPanelSaveUpdateRow(loadContentdata);
                deferred.resolve();
            }
            else
            {
                container = data.container || container;
                area = data.area || area;
                controller = data.controller || controller;
                refreshAction = data.refreshAction || refreshAction;
                id = data.id || id;
                popupId = data.popupId || popupId;

                deferred = skyward.window.loadContent(container, area, controller, refreshAction, id, loadContentdata, popupId);
            }
        }

        return deferred.promise();
    };

    /**
    * Save the  Data Object Viewer by manually passing in the save parameters.
    *
    * @param {string} container - The id of the Data Object Viewer container
    * @param {string} area - The Area/Module part of the path to the save action
    * @param {string} controller - The Controller/Object part of the path to the save action
    * @param {string} refreshAction - The Screen/Action of the current screen
    * @param {string|number} id - The id/primaryKey of the object in the Data Object Viewer
    * @param {string} popupId - The id of the popup if the Data Object Viewer is within a popup
    * @param {string} saveAction - The name of the Save action
    * @param {boolean} goBack - Return to the previous url after the save completes?
    * @param {string} tab - The name of the current tab, if within a screen with a tab
    * @param {boolean} showingDetailsPanel - Is the Data Object Viewer displayed within a details panel?
    * @param {boolean} preventRedirect - Should the redirect after save be prevented?
    * @param {object} postData - Key/Value pairs to post with the save request
    * @param {object} settings - An object of save settings
    * @return {Promise} A promise that is resolved when the save completes successfully; rejected when the save fails for any reason.
    */
    function doSave(container, area, controller, refreshAction, id, popupId, saveAction, goBack, tab, showingDetailsPanel, preventRedirect, postData, settings)
    {
        var defaultSettings =
        {
            cmaContainerId: container,
            dirtyOverride: false,
            saveButtonSelector: "#" + container + "_save"
        };

        var saveSettings = $.extend({}, defaultSettings, settings);

        var saveButton = $(saveSettings.saveButtonSelector);
        if (!saveButton.hasClass("dirty") && !saveSettings.dirtyOverride)
        {
            return;
        }

        var jQContainer = $("#" + container);
        var jQBody = $(document.body);
        jQBody.addClass("cursor-progress");

        if (!skyward.dataobjectviewer.preSaveValidation(jQContainer))
        {
            jQContainer.trigger(eventNames.DOVSaveValidationError);
            jQBody.removeClass('cursor-progress');
            return;
        }

        var url = skyward.global.virtualDir + area + "/" + controller + "/" + saveAction + "/";
        var baseErrorContainer = jQContainer.find(".currentRecordContentBaseError");
        var deferredClick = $.Deferred();

        if (id)
        {
            url += id;
        }


        skyward.dataobjectviewer.getFieldValues.getFieldValues(jQContainer).then(fieldValues =>
        {
            var values = $.extend({}, postData, fieldValues);
            values['warninghash'] = jQContainer.data("warninghash") || "";
            values['preSaveWarningHash'] = jQContainer.data("preSaveWarningHash") || "";
            values['editableFields'] = skyward.controls.getEditableFields(jQContainer);
            values['goBack'] = goBack;
            values['dataObjectViewer_RefreshAction'] = refreshAction;
            values.skipFiscalYearScopeCheck = "true";

            $.ajax(
                {
                    url: url,
                    type: "POST",
                    success: async function (data)
                    {
                        if (data)
                        {
                            if (data.success)
                            {
                                // If deferred, then we process save using taskstatus.js
                                if (data.deferred)
                                {
                                    skyward.dataobjectviewer.getFieldValues.disableButtons(container);

                                    var onValidationError = function (data)
                                    {
                                        skyward.dataobjectviewer.getFieldValues.enableButtons(container);
                                        skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                                        jQContainer.trigger(eventNames.DOVSaveValidationError);
                                    };

                                    var OnCompleted = async function (deferredData)
                                    {
                                        // Called to clear out any existing validation messages
                                        skyward.validation.displayValidationMessages(deferredData, container, baseErrorContainer);
                                        await skyward.changeTracking.clearDirtyList(container);
                                        deferredData.confirmationMessage = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        values['confirmationMessage'] = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        deferredData.confirmationMessageContainer = container;
                                        deferredData.skipFiscalYearScopeCheck = "true";
                                        if (!preventRedirect)
                                        {
                                            redirectAfterAsyncProcess(deferredData, container, area, controller, refreshAction, id, popupId, goBack || data.goBack, tab, showingDetailsPanel);
                                        }

                                        jQContainer.trigger(eventNames.DOVSaveComplete);
                                    };

                                    // Deferred, ping and show status
                                    skyward.buttonManager.waitForFunction(deferredClick, skyward.taskstatus.beginAsyncStatusReport(data.workflowInstanceID, OnCompleted, null, onValidationError, 5000));

                                    return;
                                }
                                else
                                {
                                    data.skipFiscalYearScopeCheck = "true";
                                    jQBody.removeClass('cursor-progress');
                                    await skyward.changeTracking.clearDirtyList(container);
                                    skyward.dataobjectviewer.getFieldValues.enableButtons(container);

                                    var contentArea = jQContainer.parent();
                                    const cma = skyward.contentMessageArea.getContentMessageArea(contentArea);

                                    if (!$.isEmptyObject(data.settings))
                                    {
                                        if (cma)
                                        {
                                            var message = data.settings.redirectMessage ? data.settings.redirectMessage : skyward.contentMessageArea.getDefaultConfirmationMessage();
                                            cma.setConfirmationMessage(message);
                                            cma.showConfirmation();
                                        }

                                        contentArea.find('.contentMessageArea').on('SaveAnimationRedirect', function ()
                                        {
                                            skyward.window.loadContent(data.settings.target, data.settings.area, data.settings.controller, data.settings.action, data.settings.id ?? data.id);
                                        });
                                    }
                                    else
                                    {
                                        data.confirmationMessage = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        values['confirmationMessage'] = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                        data.confirmationMessageContainer = container;

                                        if (cma)
                                        {
                                            var message = skyward.contentMessageArea.getDefaultConfirmationMessage();
                                            cma.setConfirmationMessage(message);
                                            cma.showConfirmation();
                                        }

                                        if (!preventRedirect)
                                        {
                                            var deferred = redirectAfterAsyncProcess(data, container, area, controller, refreshAction, id, popupId, goBack, tab, showingDetailsPanel);
                                            jQContainer.trigger(eventNames.DOVSaveComplete);
                                            deferred.always(function () { deferredClick.resolve(); });
                                            return;
                                        }
                                    }
                                    jQContainer.trigger(eventNames.DOVSaveComplete);
                                }
                                deferredClick.resolve();
                            }
                            else
                            {
                                jQBody.removeClass("cursor-progress");
                                skyward.validation.displayValidationMessages(data, saveSettings.cmaContainerId, baseErrorContainer, false);
                                data = { Update: data.Update };
                                skyward.ajax.handleResponse(data, null, true, skyward.window.getClosestContentPanel(jQContainer));
                                jQContainer.trigger(eventNames.DOVSaveValidationError);
                                const error = new skyward.error.CancellationError("dataobjectviewer save unsuccessful");
                                error.statusCode = 200; // This is needed to bypass jQuery.Deferred.exceptionHook
                                deferredClick.reject(error);
                            }
                        }
                    },
                    error: function ()
                    {
                        deferredClick.reject();
                    },
                    data: values
                });
        });
        return deferredClick.promise();
    }

    /**
    * Cancel any pending changes within the Data Object Viewer by manually passing in the save parameters.
    *
    * @param {string} container - The id of the Data Object Viewer container
    * @param {string} area - The Area/Module part of the path to the save action
    * @param {string} controller - The Controller/Object part of the path to the save action
    * @param {string} action - The Screen/Action of the current screen
    * @param {string|number} id - The id/primaryKey of the object in the Data Object Viewer
    * @param {string} popupId - The id of the popup if the Data Object Viewer is within a popup
    * @param {string} tab - The name of the current tab, if within a screen with a tab
    * @param {boolean} showingDetailsPanel - Is the Data Object Viewer displayed within a details panel?
    * @param {boolean} skipCancelAction - Should the page be reloaded instead of reloading the action?
    * @param {boolean} preventRedirect - Should the redirect after save be prevented?
    */
    async function doCancel(container, area, controller, action, id, popupId, tab, showingDetailsPanel, skipCancelAction, preventRedirect)
    {
        var cancelButton = $("#" + container + "_cancel");

        if (cancelButton.hasClass("dirty"))
        {
            var target = "moduleContent";
            var data =
            {
                tab: tab,
                skipFiscalYearScopeCheck: "true"
            };

            if (showingDetailsPanel)
            {
                var postedData = skyward.detailsPanel.getData();
                data = $.extend({}, postedData, data);
                target = "detailsPanel";
            }

            await skyward.changeTracking.clearDirtyList(container, window, true);

            $("#" + container).trigger(eventNames.DOVSaveCanceled, [{ target: target, area: area, controller: controller, action: action, id: id, data: data, popupId: popupId }]);

            if (preventRedirect)
            {
                return;
            }

            if (skipCancelAction)
            {
                window.location.reload(true);
            }
            else
            {
                skyward.window.loadContent(target, area, controller, action, id, data, popupId);
            }
        }
    }

    /**
    * Delete the Data Object Viewer by manually passing in the save parameters.
    *
    * @param {string} area - The Area/Module part of the path to the delete action
    * @param {string} controller - The Controller/Object part of the path to the delete action
    * @param {string} action - The Screen/Action part of the path to the delete action
    * @param {string|number} id - The id/primaryKey of the object in the Data Object Viewer
    * @param {string} urlReferrer - The name url of the current page
    * @param {boolean} profileBrowseID - The browse id of the current profile, if within a profile
    * @return {Promise} A promise that is resolved when the save completes.
    */
    function doDelete(area, controller, action, id, urlReferrer, profileBrowseID)
    {
        var container = "moduleContent";
        var jQContainer = $("#" + container);
        var jQBody = $(document.body);
        jQBody.addClass("cursor-progress");

        var url = skyward.global.virtualDir + area + "/" + controller + "/" + action + "/";
        var baseErrorContainer = jQContainer.find(".currentRecordContentBaseError");
        var deferredClick = $.Deferred();

        if (id)
        {
            url += id;
        }

        if (profileBrowseID)
        {
            skyward.browsePreferences.setPreferences(parseInt(profileBrowseID), { seekId: null });
        }

        var warninghash = jQContainer.data("warninghash") || "";

        $.ajax(
            {
                url: url,
                type: "POST",
                success: function (data)
                {
                    if (data)
                    {
                        if (data.success)
                        {
                            // If deferred, then we process save using taskstatus.js
                            if (data.deferred)
                            {
                                var onValidationError = function (data)
                                {
                                    skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                                };

                                var OnCompleted = function (data)
                                {
                                    // Called to clear out any existing validation messages
                                    skyward.validation.displayValidationMessages(data, container, baseErrorContainer);
                                    skyward.breadcrumb.removeStaledBreadcrumbs(urlReferrer);
                                    redirectAfterAsyncProcess(data, container, area, controller, action, id, null, true, null, null, urlReferrer);
                                };

                                // Deferred, ping and show status
                                skyward.buttonManager.waitForFunction(deferredClick, skyward.taskstatus.beginAsyncStatusReport(data.workflowInstanceID, OnCompleted, null, onValidationError, 5000));

                                return;
                            }
                            else
                            {
                                jQBody.removeClass("cursor-progress");
                                skyward.breadcrumb.removeStaledBreadcrumbs(urlReferrer);
                                redirectAfterAsyncProcess(data, container, area, controller, action, id, null, true, null, null, urlReferrer);
                            }
                        }
                        else
                        {
                            jQBody.removeClass("cursor-progress");
                            skyward.validation.displayValidationMessages(data, container, baseErrorContainer, true);
                        }

                        deferredClick.resolve();
                    }
                },
                error: function ()
                {
                    deferredClick.resolve();
                },
                data: warninghash
            });

        return deferredClick.promise();
    }

    function saveHandler(button, goBack, preventRedirectOverride)
    {
        var toolbar = $(button).closest(".toolbar");
        var dovContainer = $("#" + toolbar.data().dovId);
        var data = dovContainer.data();
        var refreshAction = getRefreshAction(data, goBack);
        var preventRedirect = preventRedirectOverride !== undefined ? preventRedirectOverride : data.preventredirect;
        var tab = !goBack && data.tabtoroute !== null ? data.tabtoroute : data.tab;
        return doSave(dovContainer.attr("id"), data.module, data.object, refreshAction, data.primaryid, data.popupid + "", data.saveaction, goBack, tab, data.detailspanel, preventRedirect);
    }

    function cancelHandler()
    {
        var toolbar = $(this).closest(".toolbar");
        var dovContainer = $("#" + toolbar.data().dovId);
        var data = dovContainer.data();
        var refreshAction = getRefreshAction(data, false);
        var tab = data.tabtoroute !== null ? data.tabtoroute : data.tab;
        doCancel(dovContainer.attr("id"), data.module, data.object, refreshAction, data.primaryid, data.popupid + "", tab, data.detailspanel, data.skipcancelaction, data.preventredirect);
    }

    function getRefreshAction(data, goingBack)
    {
        var refreshAction = data.refreshaction.toLowerCase() === "edit" ? "Details" : data.refreshaction;
        if (goingBack)
        {
            return refreshAction;
        }
        if (data.routetodetails === true)
        {
            refreshAction = "Details";
        }
        else if (data.pagetoroute !== null)
        {
            refreshAction = data.pagetoroute;
        }
        return refreshAction;
    }

    var events =
    {
        save: function () { return saveHandler(this, false); },
        saveAndBack: function () { return saveHandler(this, true, false); },
        cancel: cancelHandler,
        initChangeTracking: function () { skyward.changeTracking.setUpChangeTracking(this); },
        initAccessibility: function ()
        {
            // Use the first section header label as the label of the DOV Form
            const dataObjectViewer = $(this)
            const firstHeaderId = dataObjectViewer.find(".sectionHeader .sectionHeader__text").first().addIds().attr("id");
            dataObjectViewer.attr("aria-labelledby", firstHeaderId);
        }
    };

    return events;
});
